import api from "../../../../api/axios"

export default class BankAccounts {
	static async getBanks() {
		const url = "/bank"
		const response = await api.get(url)

		const banks = response?.data?.data?.map((bank) => {
			const { routingNumber, bankName } = bank
			bank.displayName = `${routingNumber} - ${bankName}`

			return [routingNumber, bank]
		})

		return new Map(banks)
	}

	static async getEmployeeGroups({ employerId }) {
		const url = `employer/${employerId}/account`
		const response = await api.get(url)

		return response?.data?.employerAccounts?.employeeGroups
	}

	static async addBankAccount({ employerId, payload }) {
		const url = `employer/${employerId}/bankAccount`
		const response = await api.post(url, payload )

		return response?.data
	}

	static async setBankAccount({ employerId, employeeGroups, bankAccountId, setBilling }) {
		try {
			const uses = ["employerContributions", "employeeContributions", "employeeReimbursements"]

			employeeGroups = employeeGroups?.map((employeeGroup) => {
				const employeeGroupId = employeeGroup?.employeeGroupId

				let accounts = employeeGroup?.accounts?.map((account) => {
					const planType = account?.planType

					const allowedUses = structuredClone(uses).filter((use) => account?.[use])
					return allowedUses.map((use) => ({ employeeGroupId, id: bankAccountId, use, planType }))
				})

				accounts = accounts?.flat()

				if (setBilling) {
					accounts?.push({ employeeGroupId, id: bankAccountId, use: "billing", accountType: "BANK_ACCOUNT" })
				}

				return accounts
			})

			const url = `employer/${employerId}/account`
			const promises = employeeGroups?.flat()?.map((payload) => api.post(url, payload))

			return await Promise.all(promises)
		} catch (error) {
			console.error(error)
		}
	}
}
